import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const HeaderContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    position: 'sticky',
    zIndex: 1000,
    margin: '0 auto',
    maxWidth: '1600px',
    borderRadius: '16px',
    // Different styles based on breakpoint
    [theme.breakpoints.up('xs')]: {
        top: 5,
        margin: '0',
    },
    [theme.breakpoints.up('sm')]: {
        top: 15,
        width: '99%',
        margin: '0 auto',
        backgroundColor: 'rgba(46, 54, 73, 0.6)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    },
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '0 10px',
    transition: 'all 0.2s ease',
}));

export const NavLinksContainer = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    transition: 'all 0.3s ease',
}));

export const HamburgerButton = styled(Box)(({ theme }) => ({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(12px)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease',
}));
